
export default {
  name: 'Tab',
  components: {
  },
  props: {
    title: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    desc: {
      type: String,
      default: ''
    },
    titType: {
      type: String,
      default: ''
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      active: '1', // 탭 index(활성화)
      tabIndex: ['1'] // 아코디언 index
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
    if (this.isActive !== undefined) {
      this.active = this.isActive
    }
  },
  mounted () {
  },
  unmounted () {
  },
  methods: {
    prodNum (e) {
      if (typeof e === 'number') {
        if (e > 99999) {
          return '99,999+'
        } else {
          // console.log(e > 99999, 'AAAAAAAAAA')
          return Number(e).toLocaleString('ko-KR')
        }
      } else if (Number(e.replace(/[^0-9]/g, '')) > 99999) {
        return '99,999+'
      } else {
        return Number(e.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    }
  }
}
